import React, { useState, useEffect } from 'react';
// components
import Divider from '@mui/material/Divider';
import { Button, Card, CardContent, Box, Stack, Typography } from '@mui/material';
import Swal from 'sweetalert2';

import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage, compruebaForm } from '../../auxiliares/funciones';
import ClienteForm from './form/form';
import Recuadro from '../../componentes/Recuadro';
import CitasClienteTabla from './form/citas_cliente';
import CuponesClienteTabla from './form/cupones_cliente';

export default function AltaForm(props) {
  const usuario = workWithLocalStorage('get', 'usuario', null);
  const Form = { vip: 0, nombre: '', apellidos: '', dni: '', telefono: '', email: '', notas: '' };
  const obligatorios = ['nombre', 'apellidos', 'telefono'];

  const [cliente, setCliente] = useState(Form);
  const [citas, setCitas] = useState([]);
  const [cupones, setCupones] = useState([]);
  const [cargado, setCargado] = useState(false);
  const [id, setId] = useState(props.params?.id ? props.params.id : '0');

  const cargarSubtablas = (clienteId) => {
    const targetId = clienteId || id;
    if (!targetId || targetId === '0') return;

    const bodyJson = JSON.stringify(buildBody(usuario.token, { id: targetId }));

    // Cargar citas del cliente
    fetch(`${CONFIG.api}cliente/citas`, {
      method: 'POST',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error === 0 && Array.isArray(result.data)) {
          setCitas(result.data);
        }
      })
      .catch((e) => console.error('Error al cargar citas del cliente:', e));

    // Cargar cupones del cliente
    fetch(`${CONFIG.api}cliente/cupones`, {
      method: 'POST',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.error === 0 && Array.isArray(result.data)) {
          setCupones(result.data);
        }
      })
      .catch((e) => console.error('Error al cargar cupones del cliente:', e));
  };

  useEffect(() => {
    async function cargaInicial() {
      if (!cargado) {
        if (id !== '0') {
          const bodyJson = JSON.stringify(buildBody(usuario.token, { id }));

          fetch(`${CONFIG.api}cliente/detalle`, {
            method: 'POST',
            body: bodyJson,
            headers: { 'Content-Type': 'application/json' }
          })
            .then((res) => res.json())
            .then((result) => {
              if (result.error === 0 && !isEmpty(result.data)) {
                setCliente(result.data);
              }
              if (props.showLoader) props.showLoader(false);
              setCargado(true);
            });

          cargarSubtablas(id);
        } else {
          if (props.showLoader) props.showLoader(false);
          setCargado(true);
        }
      }
    }
    cargaInicial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargado, id]);

  const Grabar = () => {
    const valido = compruebaForm(Form, cliente, obligatorios);
    if (valido) {
      if (props.showLoader) props.showLoader(true);
      const body = cliente;
      const bodyJson = JSON.stringify(buildBody(usuario.token, body));
      fetch(`${CONFIG.api}cliente/detalle`, {
        method: 'PUT',
        body: bodyJson,
        headers: { 'Content-Type': 'application/json' }
      })
        .then((res) => res.json())
        .then((result) => {
          let msg = 'Cliente grabado correctamente!';
          if (result.error === 0) {
            setId(result.data.id);
            const tabElem = document.getElementById(`simple-tab-${props.index}`);
            if (tabElem) {
              const span = tabElem.getElementsByTagName('span')[0];
              if (span) span.textContent = `Editar Cliente #${result.data.id} `;
            }
            setCargado(false);
          } else {
            if (props.showLoader) props.showLoader(false);
            msg = result.errorMessage;
          }
          Swal.fire({
            title: msg,
            buttons: [{ label: 'Ok' }]
          });
        });
    } else {
      Swal.fire({
        title: 'Revisa los campos con *',
        buttons: [{ label: 'Ok' }]
      });
    }
  };

  const Nuevo = () => {
    setCliente(Form);
    setId('0');
    setCitas([]);
    setCupones([]);
    const tabElem = document.getElementById(`simple-tab-${props.index}`);
    if (tabElem) {
      const span = tabElem.getElementsByTagName('span')[0];
      if (span) span.textContent = 'Alta Cliente ';
    }
  };

  const actualizaCampo = (input) => {
    const nombre = input.target.name;
    const valor = input.target.value;
    cliente[nombre] = valor;
    setCliente({ ...cliente });
  };

  const Activar = () => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'clientes',
      activo: 1,
      id: cliente.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Cliente activado!';
        if (result.error === 0) {
          setCargado(false);
        } else {
          if (props.showLoader) props.showLoader(false);
          msg = result.errorMessage;
        }
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  const Borrar = () => {
    if (props.showLoader) props.showLoader(true);
    const body = {
      tabla: 'clientes',
      activo: 0,
      id: cliente.id
    };
    const bodyJson = JSON.stringify(buildBody(usuario.token, body));
    fetch(`${CONFIG.api}master/activo`, {
      method: 'PUT',
      body: bodyJson,
      headers: { 'Content-Type': 'application/json' }
    })
      .then((res) => res.json())
      .then((result) => {
        let msg = 'Cliente desactivado!';
        if (result.error === 0) {
          setCargado(false);
        } else {
          if (props.showLoader) props.showLoader(false);
          msg = result.errorMessage;
        }
        if (props.showLoader) props.showLoader(false);
        Swal.fire({
          title: msg,
          buttons: [{ label: 'Ok' }]
        });
      });
  };

  return (
    <Page title="Alta Cliente">
      <Card sx={{ maxWidth: '100% !important' }}>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'space-between',
            gap: 2
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#0F172A' }}>
            {id === '0' ? 'Alta Cliente' : `Editar Cliente #${id}`}
          </Typography>

          <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
            <Button
              variant="contained"
              color="success"
              sx={{ color: 'white', fontWeight: 'bold' }}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => Grabar(null)}
            >
              Grabar
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ color: 'white', fontWeight: 'bold' }}
              to="#"
              startIcon={<Iconify icon="eva:edit-outline" />}
              onClick={() => Nuevo()}
            >
              Nuevo
            </Button>
            {cliente.id &&
              (cliente.activo === 1 ? (
                <Button
                  variant="contained"
                  color="error"
                  sx={{ color: 'white', fontWeight: 'bold' }}
                  to="#"
                  startIcon={<Iconify icon="eva:trash-2-outline" />}
                  onClick={() => Borrar()}
                >
                  Borrar
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="warning"
                  sx={{ color: 'white', fontWeight: 'bold' }}
                  to="#"
                  startIcon={<Iconify icon="eva:refresh-fill" />}
                  onClick={() => Activar()}
                >
                  Activar
                </Button>
              ))}
          </Stack>
        </Box>
        <Divider />

        {/* 1. DATOS DEL CLIENTE */}
        <CardContent>{cargado && <ClienteForm showLoader={props.showLoader} cliente={cliente} actualizaCampo={actualizaCampo} />}</CardContent>

        {/* 2. TABLAS SECUNDARIAS DE DETALLE (CITAS Y CUPONES) */}
        {cargado && cliente.id && (
          <CardContent sx={{ pt: 0 }}>
            {/* TABLA 1: DETALLE DE NÚMERO DE CITAS (SÓLO CONSULTA, SIN BOTONES) */}
            <Recuadro titulo={'Detalle de Número de Citas (Agenda)'}>
              <CitasClienteTabla citas={citas} />
            </Recuadro>

            {/* TABLA 2: DETALLE DE CUPONES COMPRADOS / USADOS Y SU ESTADO */}
            <Recuadro titulo={'Detalle de Cupones (Comprados / Usados)'} extrasx={{ marginTop: '30px !important' }}>
              <CuponesClienteTabla idCliente={cliente.id} cupones={cupones} onRefresh={() => cargarSubtablas(cliente.id)} />
            </Recuadro>
          </CardContent>
        )}
      </Card>
    </Page>
  );
}
